import { call, put, takeLatest } from "redux-saga/effects";
import { donHangApi } from "../../../api/don-hang/donHangApi";
import { ICommonRequest } from "../../../model/request/ICommonRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eDonHangActionTypeIds, IDonHangActions } from "../../action-types/don-hang/IDonHangActions";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.donHang.donHang;

export function* donHangSearchSaga(): any {
    yield takeLatest(eDonHangActionTypeIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IDonHangActions): any {
    const searchRequest = action.payload as ICommonRequest;
    const res: IBaseRespone = yield call(donHangApi.SelectAll, searchRequest);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}
